import { Component, OnInit } from '@angular/core';
import { TermService } from '../service/term.service';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-term-of-service-v1',
  templateUrl: './term-of-service-v1.component.html',
  styleUrls: ['./term-of-service-v1.component.css'],
})
export class TermOfServiceV1Component implements OnInit {
  constructor(private termService: TermService, private route: Router) {}

  ngOnInit(): void {}

  send(accept: Boolean) {
    confirm(`tem certeza que deseja ${accept ? 'aceitar' : 'rejeitar'}`);
    this.termService
      .acceptByUser('1', accept)
      .then((res) => {
        this.route.navigateByUrl('/');
      })
      .catch((err) => console.log(err));
  }
}
